(() => {
  'use strict';
  
  const SHORTCODE_PATTERN = /\[product_card([^\]]+)\]/g;
  
  const parseAttributes = (attributeString) => {
    const attributes = {};
    const attrPattern = /(\w+)="([^"]*)"/g;
    let match;

    while ((match = attrPattern.exec(attributeString)) !== null) {
      attributes[match[1]] = match[2];
    }

    return attributes;
  };
  
  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };
  
  const generateProductCardHTML = (attributes) => {
    const {
      border = '',
      image = '',
      eyebrow = '',
      product_name = '',
      alt_text = '',
      cta_url = '',
      cta_text = 'Shop Now',
      target = ''
    } = attributes;
    
    const hasBorder = border && border !== 'false' && border !== 'none';
    const borderStyle = hasBorder ? `border: 1px solid ${border};` : '';
    
    const isNewTab = target === '_blank';
    const targetAttr = isNewTab ? ` target="_blank" rel="noopener noreferrer"` : '';

    let html = `<div class="fnks-2025-product-card-shortcode" style="${borderStyle}">`;
    
    const linkUrl = cta_url || '#';
    html += `<a href="${escapeHtml(linkUrl)}" class="fnks-2025-product-card-link"${targetAttr}>`;
    
    if (image && image !== 'false') {
      const imageAlt = alt_text || product_name || 'Product';
      html += `<div class="fnks-2025-product-card-image">`;
      html += `<img src="${escapeHtml(image)}" alt="${escapeHtml(imageAlt)}" loading="lazy">`;
      html += `</div>`;
    }
    
    html += `<div class="fnks-2025-product-card-content">`;
    
    if (eyebrow && eyebrow !== 'false') {
      html += `<div class="fnks-2025-product-card-eyebrow">${escapeHtml(eyebrow)}</div>`;
    }
    
    if (product_name && product_name !== 'false') {
      html += `<h3 class="fnks-2025-product-card-title">${escapeHtml(product_name)}</h3>`;
    }
    
    if ((product_name && product_name !== 'false') && (cta_url && cta_url !== 'false')) {
      html += `<div class="fnks-2025-product-card-divider"></div>`;
    }
    
    if (cta_url && cta_url !== 'false') {
      html += `<div class="fnks-2025-product-card-cta">`;
      html += `<span class="fnks-2025-product-card-button">${escapeHtml(cta_text)}</span>`;
      html += `</div>`;
    }
    
    html += `</div>`;
    html += `</a>`;
    html += `</div>`;
    
    return html;
  };
  
  const processShortcodes = () => {
    const articleContent = document.querySelector('.article__content .rte');
    if (!articleContent) return;
    
    let content = articleContent.innerHTML;
    const matches = [...content.matchAll(SHORTCODE_PATTERN)];
    
    if (matches.length === 0) return;
    
    matches.forEach(match => {
      const [fullMatch, attributeString] = match;
      const attributes = parseAttributes(attributeString);
      const cardHTML = generateProductCardHTML(attributes);
      content = content.replace(fullMatch, cardHTML);
    });
    
    articleContent.innerHTML = content;
  };
  
  const init = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processShortcodes);
    } else {
      processShortcodes();
    }
  };
  
  init();
})();
